import { OAuthConsentPage as OAuthConsentPageView } from './OAuthConsentPage';
import { PageStoreContainer } from './store';

export const OAuthConsentPage = () => (
  <PageStoreContainer>
    <OAuthConsentPageView />
  </PageStoreContainer>
);
